jQuery(document).ready((function($){

    var itemsTransitionSpeed = 600;
    var popupOverlay = $('#js-popup-slider-overlay');
    var popupSliderWrap = $('#js-popup-slider__wrap');
    var popupLoader = $('#js-popup__loader');
    var popupCloseButton = $('js-popup-slider__button');
    var map = null;
    var infoBubble;
    var map_styles = [];
    var popupSlider;
    var popupContentSlider;

        popupSlider = $('#popup-slider__media').owlCarousel({
      loop: true,
      items: 1,
      responsive: {
        0: {
          dots: false,
          nav: true
        },
        1030: {
          dots: true,
          nav: false,
        }
      }
    });

    if ( is_corporate_homepage() ) {
        map_styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
    }

    $('.google_map__map').each((function() {
        map = new_map($(this));
    }));

    popupOverlay.on( "click", ".popup-slider__button", (function(e) {
      e.preventDefault();
      hideElement(popupOverlay);
      hideElement(popupSliderWrap);
      $("body").removeClass("disable-scroll");
    }));

    function new_map($el) {

        var $markers = $el.find('.google_map__marker');

        var args = {
          zoom:               13,
          center:             new google.maps.LatLng(0, 0),
          mapTypeId:          google.maps.MapTypeId.ROADMAP,
          mapTypeControl:     false,
          draggable:          true,
          scaleControl:       false,
          navigationControl:  false,
          streetViewControl:  false,
          zoomControl:        ( is_corporate_homepage() ) ? false : true,
          scrollwheel:        false,
          styles:             map_styles
        };

        var map = new google.maps.Map($el[0], args);

        map.markers = [];
        $markers.each((function() {
            add_marker($(this), map);
        }));
        center_map(map);
        return map;
    }

    function add_marker($marker, map) {

        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
            tax_id: $marker.attr('data-id') || null
        });

        map.markers.push(marker);

        if ($marker.html().trim()) {

            if ( is_corporate_homepage() ) {
              google.maps.event.addListener(marker, 'click', (function() {
                updatePopupCarousel(marker.tax_id);
              }));
            } else {
              createNativeInfoWindow( $marker.html(), marker );
            }         

                    }

    }

    function center_map(map) {

        var bounds = new google.maps.LatLngBounds();

        $.each(map.markers, (function(i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        }));

        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
            map.setZoom(14);
        } else {
            map.fitBounds(bounds);
        }

        if (map.markers.length !== 1) {
          google.maps.event.addDomListener( window, "resize", helpers.debounce( (function() {
            map.fitBounds( bounds );
          }), 200));
        }

    }

    function createNativeInfoWindow( marker_content, marker ) {
      var infowindow = new google.maps.InfoWindow({
        content: marker_content,
        maxWidth: 800
      });

      google.maps.event.addListener(marker, 'click', (function() {
        console.log(marker);
        console.log(marker_content)
        infowindow.open(map, marker);
      }));

      if(marker.data('open')==true){
        infowindow.open(map, marker);
      }
    }


    function is_corporate_homepage() {
      return wgd_params.is_corporate_homepage === '1';
    }

    function updatePopupCarousel( taxonomy_id ) {
      let newSliderContent;
      let taxonomyUrl = `${wgd_params.site_url}/wp-json/wp/v2/regions/${taxonomy_id}`;
      let postsUrl = `${wgd_params.site_url}/wp-json/wp/v2/global_portfolio?regions=${taxonomy_id}`;

      showElement(popupOverlay);
      $("body").addClass("disable-scroll");
      showElement(popupLoader);

      axios.all([ axios.get(taxonomyUrl), axios.get(postsUrl) ])
            .then(axios.spread((function (taxonomy, posts) {
              let tax_image = taxonomy.data.acf.region_featured_image;
              if (!tax_image){
                tax_image = `${wgd_params.assets_path}/tax_dummy_image.png`;
              }
              console.log(tax_image);
              newSliderContent = createSliderItem(tax_image, taxonomy.data.acf.region_description);
              posts = posts.data;
              posts.forEach( post => {
                newSliderContent += createSliderItem( post.acf.global_portfolio_single_image, post.acf.global_portfolio_single_conent )
              });

              popupSlider.trigger('replace.owl.carousel', newSliderContent)
                         .trigger('refresh.owl.carousel')
                         .trigger('to.owl.carousel', 0);

              setTimeout( () => {
                hideElement(popupLoader);
                showElement(popupSliderWrap);
              }, 200)


                   })));
    }

    function createSliderItem( image, description ) {
      let content = `
        <div class="item popup-slider__item">
          <div class="popup-slider__media">
            <img src="${image}" alt="" aria-hidden="true">
          </div>
          <div class="popup-slider__content"><div>${description}</div></div>
        </div>
      `;
      return content;
    }

    function showElement(element) {
      element.addClass('is-active');
    }

    function hideElement(element) {
       element.removeClass('is-active');
    }



}));
